import { LinkItem } from '@occc-app/design-system';

import { routeCreator as scanDataRouteCreator } from '../../scan-data.router';

export const buildSubmissionGroupDetailsBreadcrumbs = (label: string): LinkItem[] => [
  {
    label: 'Tobacco Offers',
    to: scanDataRouteCreator.base(),
  },
  { label: 'Details', to: scanDataRouteCreator.submissionGroups() },
  { label },
];
